import { createPortal } from 'react-dom'
import type { Game } from '../../types/game'
import { ResourceIcon } from '../shared/ResourceIcon'

interface WoollyFurChoiceModalProps {
  game: Game
  onChoose: (resource: 'nectar' | 'pollen') => void
}

export function WoollyFurChoiceModal({ game, onChoose }: WoollyFurChoiceModalProps) {
  const pending = game.pending_woolly_fur_choice
  if (!pending) return null

  const appRoot = document.querySelector('.app') ?? document.body

  return createPortal(
    <div className="nesting-modal-root">
      <div className="nesting-modal-overlay" />
      <div className="nesting-modal tableau">
        <div className="nesting-modal-options woolly-fur-modal">
          <div className="woolly-fur-modal-title">Woolly Fur</div>
          <div className="nesting-modal-option-row">
            <div className="woolly-fur-modal-option" onClick={() => onChoose('nectar')}>
              <span className="woolly-fur-modal-plus">+</span>
              <ResourceIcon resource="nectar" className="woolly-fur-modal-token" />
            </div>
            <div className="woolly-fur-modal-option" onClick={() => onChoose('pollen')}>
              <span className="woolly-fur-modal-plus">+</span>
              <ResourceIcon resource="pollen" className="woolly-fur-modal-token" />
            </div>
          </div>
        </div>
      </div>
    </div>,
    appRoot
  )
}
